export enum API_STATUS {
  LOADING = 'loading',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export enum DATE_TIME_FORMAT {
  HOURS_MINUTES = 'HH:mm',
}

export const REDUX_KEY = {
  MASTER_COMPANY: 'masterCompany',
};

export const MODAL_TYPE = {
  REGISTRATION: 'registration',
  DETAIL: 'detail',
  UPDATE: 'update',
  DELETE: 'delete',

  CONFIRM_REGISTRATION: 'confirm_registration',
  CONFIRM_UPDATE: 'confirm_update',

  CONFIRM_REGISTRATION_FINAL: 'confirm_registration_final',
  CONFIRM_UPDATE_FINAL: 'confirm_update_final',

  SUCCESS_REGISTRATION: 'success_registration',
  SUCCESS_UPDATE: 'success_update',
  SUCCESS_DELETE: 'success_delete',

  FAIL_REGISTRATION: 'fail_registration',
  FAIL_UPDATE: 'fail_update',
  FAIL_DELETE: 'fail_delete',
};

// vams business only has 2 roles (matches Roles.ADMIN / Roles.STORE_OWNER in
// the backend's Constant.cs, and the role_code values seeded in m_roles).
export const USER_ROLE = {
  ADMIN: 'ADMIN',
  STORE_OWNER: 'STORE_OWNER',
};

export const CAMERA_ERR_CODE = {
  OK: 'Ok',
  TIME_OUT_ERR: 'TimeoutError',
  CONNECTION_BROKEN_ERR: 'ConnectionBrokenError',
  UNAUTHORIZED_ERR: 'UnauthorizedError',
  UNKNOWN_ERR: 'UnknownError',
  CANNOT_CONNECT_ERR: 'CannotConnect',
};

export const REGEX_CHARACTER_NUMBER = /^[a-zA-Z0-9 ]*$/;

export const ROLE_DATA = [
  {
    label: '1_経理部',
    value: USER_ROLE.ADMIN,
  },
  {
    label: '2_店舗',
    value: USER_ROLE.STORE_OWNER,
  },
];

export const COMMON_CONSTANT = {
  //VALIDATE ERROR CODE
  VALIDATE_USER: {
    USER_NOT_EXSITED: 'UserNotExist',
    STORE_NOT_EXISTED: 'StoreNotExist',
    USER_ALREADY_EXISTED: 'UserAlreadyExisted',
    INVALID_PASSWORD_FORMAT: 'InvalidPasswordFormat',
    STORE_MANAGER_ALREADY_EXISTED: 'StoreManagerAlreadyExisted',
    INVALID_NAME: 'InvalidName',
    NOT_FOUND_USER: 'NotFoundUser',
    INVALID_USERNAME_FORMAT: 'InvalidUsernameFormat',
  },

  IMPORT_MASTER_DATA_ERROR_CODE: {
    //COMMON IMPORT ERROR
    COMMON_IMPORT_EMPTY_FILE: 'ImportFileHasNoData',
    COMMON_COLUMN_NOT_CORRECT: 'ColumnNameIsNotCorrect',
    COMMON_CHECK_FOUND_BEFORE_UPDATE: 'CheckFoundBeforeUpdate',

    //VALIDATE MASTER_DATA_COMPANY
    COMPANY_DUPLICATE: 'DuplicateCompanyData',
    COMPANY_ALREADY_EXISTED: 'CompanyAlreadyExisted',
    COMPANY_INVALID_FORMAT: 'InvalidFormatImportCompanyData',
    COMPANY_DATA_MISSING: 'CompanyDataIsMissing',

    //VALIDATE MASTER_DATA_SECTOR
    SECTOR_DUPLICATE: 'DuplicateSectorData',
    SECTOR_NOT_EXISTED: 'CompanyNotExist',
    SECTOR_INVALID_FORMAT: 'InvalidFormatImportSectorData',
    SECTOR_ALREADY_EXISTED: 'CompanySectorAlreadyExisted',
    SECTOR_DATA_MISSING: 'SectorDataIsMissing',

    //VALIDATE MASTER_DATA_AREA
    AREA_DUPLICATE: 'DuplicateAreaData',
    AREA_INVALID_FORMAT: 'InvalidFormatImportAreaData',
    AREA_DATA_MISSING: 'AreaDataIsMissing',
    AREA_ALREADY_EXISTED: 'AreaAlreadyExisted',

    //VALIDATE MASTER_DATA_PROCESSING_CENTER
    PROCESSING_CENTER_DUPLICATE: 'DuplicateProcessingCenterData',
    PROCESSING_CENTER_INVALID_FORMAT: 'InvalidFormatImportProcessingCenterData',
    COMPANY_NOT_EXIST: 'CompanyNotExist',
    SECTOR_NOT_EXIST: 'SectorNotExist',
    PROCESSING_CENTER_ALREADY_EXISTED: 'ProcessingCenterCodeAlreadyExisted',
    PROCESSING_CENTER_DATA_MISSING: 'ProcessingCenterDataIsMissing',
    PROCESSING_CENTER_DATA_NAME_INVALID: 'InvalidProcessingCenterName',

    //VALIDATE MASTER_DATA_USER
    USER_DUPLICATE: 'DuplicateUserData',
    USER_INVALID_FORMAT: 'InvalidFormatImportUserData',
    STORE_NOT_EXIST: 'StoreNotExist',
    STORE_FOR_USER_NOT_EXIST: 'StoreForUserNotExist',
    COMPANY_FOR_USER_NOT_EXIST: 'CompanyForUserNotExist',
    ROLE_NOT_EXIST: 'RoleNotExist',
    USER_ALREADY_EXISTED: 'UserAlreadyExisted',
    STORE_ALREADY_HAVE_MANAGER: 'StoreAlreadyHaveAnotherManager',
    USER_DATA_MISSING: 'UserDataIsMissing',
    USER_PROCESSING_CENTER_NOT_EXISTED: 'ProcessingCenterNotExist',

    //VALIDATE MASTER_DATA_STORE
    STORE_DUPLICATE: 'DuplicateStoreData',
    STORE_INVALID_FORMAT: 'InvalidFormatImportStoreData',
    STORE_ALREADY_EXISTED: 'StoreAlreadyExisted',
    AREA_NOT_EXISTED: 'AreaNotExist',
    STORE_DATA_MISSING: 'StoreDataIsMissing',
    NOT_FOUND_STORE_CODE: 'NotFoundStore',

    //VALIDATE MASTER_DATA_CAMERA
    CAMERA_DUPLICATE: 'DuplicateIpCameraData',
    CAMERA_INVALID_FORMAT: 'InvalidFormatImportCameraData',
    CAMERA_ALREADY_EXISTED: 'IpCameraAlreadyExisted',
    CAMERA_PROCESSING_CENTER_NOT_EXISTED: 'ProcessingCenterNotExist',
    CAMERA_COMPANY_NOT_EXISTED: 'CompanyNotExist',
    CAMERA_STORE_NOT_EXISTED: 'StoreNotExist',
    CAMERA_DATA_MISSING: 'CameraDataIsMissing',
    CAMERA_IP_INVALID: 'InvalidIp',
    CAMERA_NOT_FOUND: 'CameraNotFound',
  },
  IMPORT_MASTER_DATA_MESSAGE: {
    //COMMON MSG
    COMMON_DUPLICATE_MSG: '入力ファイルには同じ値のペアが複数あります。',
    COMMON_INVALID_FORMAT_MSG: '{0}が正しくありません。',
    COMMON_ALREADY_EXISTED_MSG: '{0}はすでに存在しています。',
    COMMON_NOT_EXISTED_MSG: '{0}は無効です。',
    COMMON_IMPORT_EMPTY_FILE_MSG: '入力ファイルにはデータがありません。',
    COMMON_COLUMN_NOT_CORRECT_MSG: ' {0}列が正しくありません。',
    COMMON_DATA_MISSING_MSG: '{0}が入力されていません。',
    COMMON_WRONG_FILE_FORMAT_MSG: '.csvのファイルを選択してください。',
    COMMON_WRONG_FILE_SIZE_MSG: '10MB未満のファイルを選択してください。',
    STOREMANAGER_ALREADY_EXISTED: 'この店舗に管理者がすでに存在している。	',
  },

  VALIDATE_SECTOR: {
    SECTOR_ALREADY_EXISTED: 'SectorAlreadyExisted',
    SECTOR_NOT_EXISTED: 'SectorNotExist',
    COMPANY_NOT_EXISTED: 'CompanyForSectorNotExist',
    INVALID_SECTOR_CODE_FORMAT: 'InvalidSectorCode',
    SECTOR_HAS_LINKED_STORES: 'SectorHasLinkedStores',
  },
};
